import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'components/alert-view';
import {
  FormattedHTMLMessage,
  defineMessages,
} from 'react-intl';
import appconfig from 'config/appconfig';
import classes from "components/alert.scss";

const messagesConfig = {
  userInvitationError: {
    messageType: appconfig.alertTypes.DANGER,
    showIcon: true,
    iconClass: 'togo-icon togo-icon-hand-raise',
    bodyResourceId: 'messages.userInvitationError.body'
  },
  userInvitationExpired: {
    messageType: appconfig.alertTypes.DANGER,
    showIcon: true,
    iconClass: 'togo-icon togo-icon-hand-raise',
    bodyResourceId: 'messages.userInvitationExpired.body'
  }
};

const t = defineMessages({
  'messages.userInvitationError.body': {
    id: 'messages.userInvitationError.body',
    defaultMessage: 'Hmm, something went wrong. Give it another try.',
  },
  'messages.userInvitationExpired.body': {
    id: 'messages.userInvitationExpired.body',
    defaultMessage: 'Your invitation has expired',
  },
});

const MessageBanner = (props) => {
  return (
    <Alert
      type={messagesConfig[props.messageId].messageType || appconfig.alertTypes.INFO}

      icon={
        <i className={`${messagesConfig[props.messageId].iconClass} text-warning ${classes.bannerMessageIcon}`} />
      }
      body={
        <span className={classes.bannerMessageText}>
          <FormattedHTMLMessage {...t[messagesConfig[props.messageId].bodyResourceId]} values={props.params} />
        </span>
      }
      handleDismiss={props.handleAlertDismiss}
    />);
};

MessageBanner.propTypes = {
  handleAlertDismiss: PropTypes.func.isRequired,
  messageId: PropTypes.string.isRequired,
  params: PropTypes.object,
};

export default MessageBanner;
